import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'; 
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
	selector: 'rds:input-mat-chip',
	templateUrl: './input-mat-chip.component.html',
	styleUrls: ['./input-mat-chip.component.scss']
})
export class InputMatChipComponent implements OnInit {

	@Input() classStyle: string = "";
	@Input() formAppearance: string = "outline";
	@Input() label: string = "";
	@Input() value: string;
	@Input() name: string = "";//unique name
	@Input() hint: string = "";
	@Input() isRemovable: boolean = true;
	@Input() placeholder: string = "";
	@Input() isSelectable: boolean = true;
	@Input() seperator: string = ";"; //value seperator, default ";"
	@Input() addOnBlur: boolean = true;
	@Input() valueOptions: string[] = [];
	@Input() hasMultiLang:boolean = false;

	@Output() valueChange = new EventEmitter<any>();
	@Output() clickTranslate = new EventEmitter<any>();

	@ViewChild('chipInput', { static: false }) chipInput: ElementRef<HTMLInputElement>;
	@ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

	lstValues: string[] = [];
	chipCtrl = new FormControl();
	filteredChip: Observable<string[]>;

	constructor() {
		this.filteredChip = this.chipCtrl.valueChanges.pipe(
			startWith(null),
			map((val: string | null) => val ? this._filter(val) : this.valueOptions.slice()));
	}

	ngOnInit() {
		if (this.value) {
			this.lstValues = this.value.split(this.seperator);
		}

	}

	add(event: MatChipInputEvent): void {
		const input = event.input;
		const value = event.value;

		// Add our fruit
		if ((value || '').trim()) {
			this.lstValues.push(value.trim());
		}

		// Reset the input value
		if (input) {
			input.value = '';
		}

		this.chipCtrl.setValue(null);
		this.value = this.lstValues.join(this.seperator);
		this.valueChange.emit(this.value);
	}

	remove(val: any): void {
		const index = this.lstValues.indexOf(val);

		if (index >= 0) {
			this.lstValues.splice(index, 1);
		}

		this.value = this.lstValues.join(this.seperator);
		this.valueChange.emit(this.value);
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.lstValues.push(event.option.viewValue);
		this.chipInput.nativeElement.value = '';
		this.chipCtrl.setValue(null);

		this.value = this.lstValues.join(this.seperator);
		this.valueChange.emit(this.value);
	}

	openDialogTranslate(){
		this.clickTranslate.emit();
	}

	private _filter(value: string): string[] {
		const filterValue = value.toLowerCase();

		return this.valueOptions.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
	}

}
